import { SearchOutlined, CustomerServiceOutlined } from "@ant-design/icons";
import { Input, Space } from "antd";
import React, { useState, useRef } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { lang } from "../../../api/config";
import styles from "./index.module.less";

const SearchInput = ({
  onChangeKeyword,
  onChangeFlag,
  onChangeSelectedIndustry,
}) => {
  const intl = useIntl();
  const inputRef = useRef(null);
  const [value, setValue] = useState("");

  // AI 弹窗逻辑
  const handleOpenAiPopup = e => {
    if (e) e.stopPropagation();

    const udeskUrl =
      lang === "cn"
        ? "https://inhand.s2.udesk.cn/im_client/?web_plugin_id=65567"
        : "https://inhand.s2.udesk.cn/im_client/?web_plugin_id=66130&language=en-us";
    const width = 480;
    const height = 800;

    const left = window.screenX + (window.outerWidth - width) / 2;
    const top = window.screenY + (window.outerHeight - height) / 2;

    const features = `width=${width},height=${height},left=${left},top=${top},scrollbars=no,resizable=no,status=no,location=no`;

    const newWindow = window.open(udeskUrl, "UdeskAiChat", features);

    if (newWindow) {
      newWindow.focus();
    } else {
      window.open(udeskUrl, "_blank");
    }
  };

  // 搜索逻辑
  const showSearch = () => {
    if (value.trim() !== "") {
      onChangeFlag(true);
      onChangeSelectedIndustry(null);
      onChangeKeyword(value);
    }
  };

  const handleKeyDown = e => {
    if (e.key === "Enter") {
      showSearch();
    }
  };

  return (
    <div className={styles.searchWrapper}>
      <Space
        className={styles.inputsRow}
        direction="horizontal"
        size={12}
      >
        {/* 左侧 - AI 框 */}
        <div className={styles.aiBoxWrapper}>
          <div className={styles.aiRow}>
            <div
              className={styles.aiBox}
              onClick={handleOpenAiPopup}
            >
              <Input
                className={styles.aiInput}
                size="small"
                placeholder={intl.formatMessage({ id: "aiPlaceholder" })}
                readOnly
                suffix={
                  <span className={styles.aiIcon}>
                    <CustomerServiceOutlined />
                  </span>
                }
              />
            </div>
            <div className={styles.aiText}>
              <div className={styles.aiTitle}>
                <FormattedMessage id="aiTitle" />
              </div>
              <div className={styles.aiDesc}>
                <FormattedMessage id="aiDesc" />
              </div>
            </div>
          </div>
        </div>

        {/* 右侧 - 文档搜索框 */}
        <div className={styles.searchBox}>
          <Input
            value={value}
            className={styles.input}
            size="small"
            ref={inputRef}
            placeholder={intl.formatMessage({ id: "searchPlaceholder" })}
            onChange={e => {
              setValue(e.target.value);
            }}
            onPressEnter={handleKeyDown}
            allowClear
            suffix={
              <span
                className={styles.searchIcon}
                onClick={e => {
                  e.stopPropagation();
                  showSearch();
                }}
              >
                <SearchOutlined />
              </span>
            }
          />
        </div>
      </Space>
    </div>
  );
};

export default SearchInput;
